import { useEffect } from 'react';

/**
 * Keeps a list selection valid: when items load, pick the first one if
 * nothing is selected or the current selection no longer appears in the
 * list. Clears the selection when the list is empty.
 */
const useAutoSelect = <T extends { id: number }>(
  items: T[] | undefined,
  selectedId: number | undefined,
  setSelectedId: (id: number | undefined) => void,
): void => {
  useEffect(() => {
    if (!items) return;
    if (items.length === 0) {
      setSelectedId(undefined);
      return;
    }
    if (!selectedId || !items.find((s) => s.id === selectedId)) {
      setSelectedId(items[0].id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items, selectedId]);
};

export default useAutoSelect;
